<div class="min-h-screen flex flex-col bg-gray-50 w-full mx-auto font-prompt relative">
  <!-- 1. Header บาร์ด้านบน -->
  <div
    class="w-full bg-(--header-background) px-4 py-4 flex items-center  justify-between sticky top-0 z-30 shadow-sm text-white">
    <button (click)="goBack()"
      class="flex items-center text-white hover:opacity-80 active:scale-95 transition-all outline-none">
      <img src="icons/arrow_back_white.svg" />
    </button>
    <h1 class="text-sm font-bold tracking-wide " style="margin-bottom: 0;">{{ currentLang === "TH"
      ? "ที่อยู่ออกใบกำกับภาษี"
      : "Billing Address" }}
    </h1>

    <div class="w-6"></div> <!-- Spacer -->
  </div>

  <!-- 2. Segmented Tabs เลือกประเภท -->
  <div class="mx-4 mt-4 bg-gray-200/60 p-1 rounded-2xl flex text-xs font-bold text-gray-500 select-none">
    <button (click)="changeTaxType('1')"
      class="flex-1 py-2.5 rounded-xl transition-all duration-300 text-center outline-none"
      [class.bg-white]="selectedTaxType === '1'" [class.text-gray-800]="selectedTaxType === '1'"
      [class.shadow-sm]="selectedTaxType === '1'">
      {{ currentLang === "TH" ? "บุคคลธรรมดา" : "Individual" }}
    </button>
    <button (click)="changeTaxType('2')"
      class="flex-1 py-2.5 rounded-xl transition-all duration-300 text-center outline-none"
      [class.bg-white]="selectedTaxType === '2'" [class.text-gray-800]="selectedTaxType === '2'"
      [class.shadow-sm]="selectedTaxType === '2'">
      {{ currentLang === "TH" ? "นิติบุคคล" : "Juristic" }}
    </button>
  </div>

  <!-- 3. กล่องค้นหาข้อมูลที่อยู่ (Local Filter) -->
  <div class="mx-4 mt-3 relative select-none">
    <img class="absolute left-3.5 top-1/2 -translate-y-1/2 " src="icons/search_slate.svg" />
    <input type="text" [(ngModel)]="searchQuery" (ngModelChange)="onSearchQueryChange()"
      [placeholder]="currentLang === 'TH' ? 'ค้นหาชื่อผู้เสียภาษี หรือที่อยู่...' : 'Search tax name or address...'"
      class="w-full bg-white border border-gray-100 text-xs rounded-xl pl-9 pr-4 py-2.5 text-gray-800 outline-none shadow-sm focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
  </div>

  <!-- 4. รายการข้อมูลที่อยู่ (Address List) -->
  <div class="flex-grow px-4 pt-4 pb-28 space-y-3 overflow-y-auto scroll-smooth select-none">
    <!-- กรณีไม่มีข้อมูลที่อยู่ -->
    <div *ngIf="filteredAddressList.length === 0" class="flex flex-col items-center justify-center py-16 text-center">
      <div class="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 mb-3 shadow-inner">
        <img src="icons/home_work_orange.svg" />
      </div>
      <p class="text-xs font-bold text-gray-400">{{ currentLang === "TH" ? "ไม่พบข้อมูลที่อยู่" : "No address found" }}
      </p>
      <p class="text-[10px] text-gray-400 mt-1">{{ currentLang === "TH" ? "กดปุ่มเพิ่มที่อยู่ด้านล่าง
        เพื่อบันทึกข้อมูลใหม่" : "Click 'Add address' below to create a new entry" }}</p>
    </div>

    <!-- กล่องการ์ดที่อยู่แต่ละรายการ -->
    <div *ngFor="let item of filteredAddressList" (click)="selectAddress(item)"
      class="bg-white rounded-3xl p-5 border border-gray-100 shadow-sm relative hover:border-amber-200 hover:bg-amber-50/5 active:scale-[0.99] transition-all cursor-pointer group text-left">
      <div class="flex items-start gap-3">
        <!-- ไอคอนบ้าน / อาคารสำนักงาน -->
        <div
          class="w-8 h-8 rounded-full bg-amber-50 flex items-center justify-center text-amber-500 group-hover:scale-105 transition-transform flex-shrink-0">
          <img src="icons/home_orange.svg" *ngIf="selectedTaxType === '1'" />
          <img src="icons/corporate_fare_orange.svg" *ngIf="selectedTaxType === '2'" />
        </div>
        <div class="flex-grow space-y-1">
          <!-- ชื่อผู้เสียภาษี / บริษัท -->
          <h3 class="text-xs font-bold text-gray-800 leading-tight group-hover:text-gray-900 transition-colors">{{
            item.full_name }}</h3>
          <!-- ชื่อบริษัทรองรับนิติบุคคล -->
          <p *ngIf="item.company_name" class="text-[10px] font-semibold text-gray-500">{{ item.company_name }}</p>
          <!-- รายละเอียดที่อยู่ -->
          <p class="text-[10px] text-gray-400 font-medium leading-relaxed mt-1">
            {{ item.address }} {{ item.sub_district }} {{ item.district }} {{ item.provinces }} {{ item.zip_code }}
          </p>
          <!-- อีเมลติดต่อ -->
          <p *ngIf="item.email" class="text-[10px] text-gray-400 font-medium flex items-center gap-1 mt-1">
            <img src="icons/mail_slate.svg" />
            {{ item.email }}
          </p>

          <!-- ป้ายประเภทสำนักงานนิติบุคคล -->
          <div class="mt-2 pt-2 border-t border-gray-50 flex items-center justify-between"
            *ngIf="selectedTaxType === '2'">
            <span *ngIf="item.headquarters"
              class="inline-flex items-center gap-1 bg-green-50 text-green-600 text-[9px] font-bold px-2 py-0.5 rounded-full">
              <span class="w-1 h-1 rounded-full bg-green-500"></span>
              {{ currentLang === "TH" ? "สำนักงานใหญ่" : "Head Office" }}
            </span>
            <span *ngIf="!item.headquarters"
              class="inline-flex items-center gap-1 bg-gray-100 text-gray-500 text-[9px] font-bold px-2 py-0.5 rounded-full">
              {{ currentLang === "TH" ? "สาขา: " : "Branch: " }} {{ item.branch || '-' }} ({{ item.branch_no || '-' }})
            </span>
          </div>
        </div>
      </div>
      <!-- ไอคอนแสดงสถานะการกดแก้ไข -->
      <img src="icons/edit_slate.svg"
        class="group-hover:text-amber-500 absolute top-4 right-4 text-base transition-colors w-5 h-5" />
    </div>
  </div>

  <!-- 5. ปุ่มเพิ่มที่อยู่ลอยคงที่ด้านล่าง (Bottom Button) -->
  <div
    class="sticky bottom-0 left-0 w-full px-6 py-4 bg-white border-t border-gray-100 flex flex-col gap-2 z-20 mt-auto">
    <button (click)="openAddressModal()"
      class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-xs font-bold rounded-xl py-3 shadow-[0_4px_12px_rgba(245,158,11,0.25)] transition-all duration-200 active:scale-95 outline-none">
      {{ currentLang === "TH" ? "เพิ่มที่อยู่ใหม่" : "Add Address" }}
    </button>
  </div>
</div>

<!-- 6. MODAL TAX (Centered popup) -->
<div *ngIf="showAddressModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4 ">
  <!-- แผ่นฟอร์มกรอกข้อมูล -->
  <div
    class="bg-white rounded-[2rem] w-full max-w-sm max-h-[85vh] overflow-y-auto px-6 pt-6 pb-8 shadow-2xl flex flex-col text-left animate-scale-up relative">

    <!-- ปุ่มปิด Modal -->
    <button (click)="closeTaxModal()"
      class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
      <img src="icons/close_slate_dark.svg" class=" w-4 h-4" />
    </button>

    <!-- หัวข้อ Modal -->
    <h2 class="text-sm font-bold text-gray-800 mb-4 pr-8">
      {{ currentLang === "TH" ? (address_id === 0 ? "เพิ่มข้อมูลที่อยู่ใบกำกับภาษี" : "แก้ไขข้อมูลที่อยู่ใบกำกับภาษี") :
      (address_id === 0 ? "Add Tax Invoice Address" : "Edit Tax Invoice Address") }}
    </h2>

    <div class="space-y-3 flex-grow scroll-smooth">

      <!-- หมายเลขผู้เสียภาษี -->
      <div>
        <label class="block font-bold text-xs text-gray-600 mb-1.5">
          {{ currentLang === "TH" ? "เลขประจำตัวผู้เสียภาษี" : "Tax ID" }}
        </label>
        <div class="flex gap-2">
          <input type="text" [(ngModel)]="taxId" (input)="onNumberInput('taxId', $event)" placeholder="1234567890123"
            maxlength="13"
            class="flex-1 bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
          <button *ngIf="selectedTaxType === '2'" (click)="getAddressByTaxId()"
            class="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-white text-[10px] font-bold rounded-xl active:scale-95 transition-all outline-none">
            {{ currentLang === "TH" ? "ค้นหาข้อมูล" : "Search" }}
          </button>
        </div>
        <span *ngIf="selectedTaxType === '2'" class="text-[9px] text-gray-400 block mt-1">
          * {{ currentLang === "TH" ? "กรอกเลขผู้เสียภาษีเพื่อดึงข้อมูลอัตโนมัติ" : "Search by Tax ID for autocomplete"
          }}
        </span>
      </div>

      <!-- สวิตช์สำนักงานใหญ่ (Head Office Toggle) -->
      <div *ngIf="selectedTaxType === '2'" class="flex items-center justify-between py-2 border-b border-gray-50">
        <span class="text-xs font-bold text-gray-700">{{ currentLang === "TH" ? "สำนักงานใหญ่" : "Head office" }}</span>
        <label class="relative inline-flex items-center cursor-pointer select-none">
          <input type="checkbox" [(ngModel)]="mainOffice" class="sr-only peer" />
          <div class="w-10 h-5 bg-gray-200 rounded-full peer peer-checked:bg-amber-400 transition-colors"></div>
          <div
            class="absolute left-0.5 top-0.5 w-4 h-4 bg-white rounded-full transitionpeer-checked:translate-x-5 peer-checked:translate-x-5 shadow-sm">
          </div>
        </label>
      </div>

      <!-- ชื่อบริษัท / ผู้เสียภาษี -->
      <div>
        <label class="block font-bold text-xs text-gray-600 mb-1.5">
          {{ currentLang === "TH" ? (selectedTaxType === '2' ? "ชื่อบริษัท / นิติบุคคล" : "ชื่อ-นามสกุล") :
          (selectedTaxType === '2' ? "Company Name" : "Full Name") }}
        </label>
        <input type="text" [(ngModel)]="taxName" [placeholder]="currentLang === 'TH' ? 'ระบุชื่อ' : 'Specify name'"
          class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
      </div>

      <!-- รายละเอียดสาขา (Branch info) -->
      <div *ngIf="!mainOffice && selectedTaxType === '2'" class="grid grid-cols-2 gap-2">
        <div>
          <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "ชื่อสาขา" : "Branch
            name" }}</label>
          <input type="text" [(ngModel)]="branchName" placeholder="สาขาหลัก"
            class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
        </div>
        <div>
          <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "รหัสประจำสาขา" :
            "Branch code" }}</label>
          <input type="text" [(ngModel)]="branchNo" placeholder="00001"
            class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
        </div>
      </div>

      <!-- เบอร์โทรศัพท์ & อีเมล -->
      <div class="grid grid-cols-2 gap-2">
        <div>
          <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "เบอร์โทรศัพท์" :
            "Phone" }}</label>
          <input type="text" [(ngModel)]="tax_phone" (input)="onNumberInput('tax_phone', $event)" maxlength="10"
            placeholder="0812345678"
            class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
        </div>
        <div>
          <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "อีเมล" : "Email"
            }}</label>
          <input type="email" [(ngModel)]="email" placeholder="abc@example.com"
            class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
        </div>
      </div>

      <!-- ที่อยู่ (เลขที่, อาคาร, หมู่บ้าน) -->
      <div>
        <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "ที่อยู่" : "Address line"
          }}</label>
        <input type="text" [(ngModel)]="address" placeholder="123/45 ถนนราษฎร์บูรณะ"
          class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
      </div>

      <!-- เลือก จังหวัด, อำเภอ, ตำบล -->
      <div class="space-y-3">
        <!-- จังหวัด -->
        <div class="relative">
          <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "จังหวัด" : "Province"
            }}</label>
          <div class="relative">
            <input type="text" [(ngModel)]="provinceSearchText" (focus)="openDropdown('province')"
              (blur)="closeDropdown('province')"
              placeholder="{{ currentLang === 'TH' ? 'เลือกจังหวัด' : 'Select Province' }}"
              class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 cursor-pointer" />
            <img src="icons/expand_more_slate_dark.svg" [class.rotate-180]="activeDropdown === 'province'"
              class=" absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none transition" />
          </div>
          <!-- Dropdown List -->
          <div *ngIf="activeDropdown === 'province'" (mousedown)="$event.preventDefault()"
            class="absolute z-50 left-0 right-0 mt-1 max-h-40 overflow-y-auto bg-white border border-gray-100 rounded-xl shadow-lg scroll-smooth py-1">
            <div *ngFor="let province of filteredProvincess" (click)="selectProvinceOption(province)"
              class="px-4 py-2 text-xs text-gray-700 hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-colors">
              {{ province.name_th }}
            </div>
            <div *ngIf="filteredProvincess.length === 0" class="px-4 py-2 text-xs text-gray-400 text-center">
              {{ currentLang === "TH" ? "ไม่พบข้อมูล" : "No matches found" }}
            </div>
          </div>
        </div>

        <!-- อำเภอ -->
        <div class="relative">
          <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "อำเภอ" : "District"
            }}</label>
          <div class="relative">
            <input type="text" [(ngModel)]="amphureSearchText" (focus)="openDropdown('amphure')"
              (blur)="closeDropdown('amphure')" [disabled]="!selectedProvinceId"
              placeholder="{{ currentLang === 'TH' ? 'เลือกอำเภอ' : 'Select District' }}"
              class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 cursor-pointer disabled:opacity-50" />
            <img src="icons/expand_more_slate_dark.svg"
              [class.rotate-180]="activeDropdown === 'amphure' && selectedProvinceId"
              class=" absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none transition" />
          </div>
          <!-- Dropdown List -->
          <div *ngIf="activeDropdown === 'amphure' && selectedProvinceId" (mousedown)="$event.preventDefault()"
            class="absolute z-50 left-0 right-0 mt-1 max-h-40 overflow-y-auto bg-white border border-gray-100 rounded-xl shadow-lg scroll-smooth py-1">
            <div *ngFor="let amphure of filteredAmphureOptions" (click)="selectAmphureOption(amphure)"
              class="px-4 py-2 text-xs text-gray-700 hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-colors">
              {{ amphure.name_th }}
            </div>
            <div *ngIf="filteredAmphureOptions.length === 0" class="px-4 py-2 text-xs text-gray-400 text-center">
              {{ currentLang === "TH" ? "ไม่พบข้อมูล" : "No matches found" }}
            </div>
          </div>
        </div>

        <!-- ตำบล -->
        <div class="relative">
          <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "ตำบล" : "Subdistrict"
            }}</label>
          <div class="relative">
            <input type="text" [(ngModel)]="tambonSearchText" (focus)="openDropdown('tambon')"
              (blur)="closeDropdown('tambon')" [disabled]="!selectedAmphureId"
              placeholder="{{ currentLang === 'TH' ? 'เลือกตำบล' : 'Select Subdistrict' }}"
              class="w-full bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 cursor-pointer disabled:opacity-50" />
            <img src="icons/expand_more_slate_dark.svg"
              [class.rotate-180]="activeDropdown === 'tambon' && selectedAmphureId"
              class=" absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none transition" />
          </div>
          <!-- Dropdown List -->
          <div *ngIf="activeDropdown === 'tambon' && selectedAmphureId" (mousedown)="$event.preventDefault()"
            class="absolute z-50 left-0 right-0 mt-1 max-h-40 overflow-y-auto bg-white border border-gray-100 rounded-xl shadow-lg scroll-smooth py-1">
            <div *ngFor="let tambon of filteredTambonOptions" (click)="selectTambonOption(tambon)"
              class="px-4 py-2 text-xs text-gray-700 hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-colors">
              {{ tambon.name_th }}
            </div>
            <div *ngIf="filteredTambonOptions.length === 0" class="px-4 py-2 text-xs text-gray-400 text-center">
              {{ currentLang === "TH" ? "ไม่พบข้อมูล" : "No matches found" }}
            </div>
          </div>
        </div>

        <!-- รหัสไปรษณีย์ -->
        <div>
          <label class="block font-bold text-xs text-gray-600 mb-1.5">{{ currentLang === "TH" ? "รหัสไปรษณีย์" : "Postal
            Code" }}</label>
          <input type="text" [(ngModel)]="zipcode" placeholder="10140" readonly
            class="w-full bg-gray-100 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-500 outline-none select-none" />
        </div>
      </div>
    </div>

    <!-- ปุ่มตกลง / บันทึกฟอร์ม -->
    <button (click)="submitAddress()"
      class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-xs font-bold rounded-xl py-3 shadow-[0_4px_12px_rgba(245,158,11,0.25)] transition-all duration-200 active:scale-95 outline-none mt-6">
      {{ currentLang === "TH" ? "บันทึกที่อยู่" : "Save Address" }}
    </button>
  </div>
</div>

<!-- หน้ากากโหลดดิ้ง -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>